import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";
import { t } from "@lingui/macro";

import {
  BASE_DROPDOWN_POSITION,
  BaseDropdown
} from "@widgets/inputs/dropdown/base.jsx";
import { DEFAULT_ICON_COLOR } from "@widgets/inputs/iconpicker/colors.js";
import {
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";
import { TOOLTIP_POSITION, Tooltip } from "@widgets/feedback/index.jsx";

import styles from "./styles.css";

export function ColorPicker({
  selectedColor = "",
  colorMapping,
  onSelectColor
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <BaseDropdown
      position={BASE_DROPDOWN_POSITION.BOTTOM}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      targetRenderer={() => {
        return (
          <div>
            {isOpen ? (
              <div className={styles.targetContainer}>
                <ColorPickerTarget
                  selectedColor={selectedColor}
                  colorMapping={colorMapping}
                />
              </div>
            ) : (
              <Tooltip
                content={t`Choose icon color`}
                position={TOOLTIP_POSITION.BOTTOM}
              >
                <div className={styles.targetContainer}>
                  <ColorPickerTarget
                    selectedColor={selectedColor}
                    colorMapping={colorMapping}
                  />
                </div>
              </Tooltip>
            )}
          </div>
        );
      }}
      listRenderer={() => {
        return (
          <div className={styles.colors}>
            {Object.keys(colorMapping).map((color) => {
              return (
                <div
                  id={color}
                  className={`${styles.circle}`}
                  style={{
                    backgroundColor: `var(${colorMapping[color]})`
                  }}
                  onClick={(e) => onSelectColor({ color: color })}
                  key={color}
                >
                  {color === selectedColor && (
                    <KfIcon
                      icon={KF_ICONS.CHECKMARK}
                      size={ICON_SIZE.SIZE_12}
                      stroke={ICON_STROKE.THIN}
                      color="--kf-color-white"
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      }}
    />
  );
}

ColorPicker.propTypes = {
  selectedColor: PropTypes.string,
  colorMapping: PropTypes.shape({
    color: PropTypes.string
  }),
  onSelectColor: PropTypes.func
};

function ColorPickerTarget({ selectedColor, colorMapping }) {
  return (
    <div
      className={styles.color}
      style={{
        backgroundColor: selectedColor
          ? `var(${colorMapping[selectedColor]})`
          : `var(${colorMapping[DEFAULT_ICON_COLOR]})`
      }}
    />
  );
}

ColorPickerTarget.propTypes = {
  selectedColor: PropTypes.string,
  colorMapping: PropTypes.shape({
    color: PropTypes.string
  })
};
